import { useMutation } from '@tanstack/react-query';
import UserService from 'api/services/httpServices/UserService';
import Cookies from 'js-cookie';
import Button from 'modules/shared-components/button/button';
import { useUserState } from 'modules/user/UserContext';
import { ReactComponent as TelegramIcon } from 'assets/img/news/telegram.svg';
import {
  TelegramLoginButtonProps,
  TgLoginWidget,
  loginWithTelegram,
} from 'modules/telegram/LoginWidget';
import config from 'config';
import { toInitData } from 'modules/telegram/core/toInitData';
import { ApiErrorNotification } from 'modules/shared-components/notification/ApiErrorNotification';
import { useWebsocketConnect } from 'api/services/websocket/useWebsocketConnect';
import { handlePostLoginAuth } from './index';

export function LoginWithTelegram({ children }: { children: React.ReactNode }) {
  const { loginUser } = useUserState();

  const { sendAuth, connect, waitForSocketOpen, isConnected } =
    useWebsocketConnect();

  const { mutate, error } = useMutation({
    mutationFn: UserService.loginWithTelegram,
    onSuccess: async ({ user_data }) => {
      await handlePostLoginAuth(
        user_data,
        { connect, waitForSocketOpen, sendAuth },
        loginUser,
        isConnected
      );
    },
  });

  return (
    <>
      <TelegramLoginButton
        dataOnauth={(user) => {
          mutate({
            initData: toInitData(user),
            referralCode: Cookies.get('referrerId') || null,
            source: 'web',
            telegramEnvironment: config.isLocalTgDev ? 'test' : 'prod',
          });
        }}
      >
        {children}
      </TelegramLoginButton>
      {error && <ApiErrorNotification error={error} />}
    </>
  );
}

const TelegramLoginButton = ({
  dataOnauth,
  children,
}: TelegramLoginButtonProps & {
  children: React.ReactNode;
}) => {
  const { mutate, isLoading } = useMutation({
    mutationFn: loginWithTelegram,
    onSuccess: dataOnauth,
  });

  return (
    <div>
      <TgLoginWidget />
      <Button
        className="w-full xxs:bg-white hover:bg-white-600 text-black-700 xxs:py-2.5"
        type="button"
        size="large"
        loading={isLoading}
        onClick={() => mutate()}
      >
        <TelegramIcon className="w-6 h-6 xxs:mr-2 text-[#54a9eb]" /> {children}
      </Button>
    </div>
  );
};
